(function (angular) {
    'use strict';

    angular.module('templates')

        /**
         *
         */
        .factory('templateService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    // urlBase = 'http://localhost:8001';
                    var fac = {

                        getTemplates: getTemplates,
                        getTemplate: getTemplate,
                        createTemplate: createTemplate,
                        updateTemplate: updateTemplate,
                        deleteTemplate: deleteTemplate
                    };

                    return fac;

                    /**
                     * GET "/apispaces/{id}/templates"
                     * @param {string} id - the api space Id
                     */
                    function getTemplates(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/templates")
                            .then(getTemplatesComplete)
                            .catch(getTemplatesFailed);

                        function getTemplatesComplete(response) {
                            return response.data;
                        }

                        function getTemplatesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispaces/{id}/templates/{templateId}"
                     * @param {string} id - the api space Id
                     * @param {string} templateId - the template id
                     */
                    function getTemplate(id, templateId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/templates/" + encodeURIComponent(templateId))
                            .then(getTemplateComplete)
                            .catch(getTemplateFailed);

                        function getTemplateComplete(response) {
                            return response.data;
                        }

                        function getTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * POST "/apispaces/{id}/templates"
                     * @param {string} id - the api space Id
                     * @param {object} data - the template data
                     */
                    function createTemplate(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/templates", data)
                            .then(getTemplateComplete)
                            .catch(getTemplateFailed);

                        function getTemplateComplete(response) {
                            return response.data;
                        }

                        function getTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * PUT "/apispaces/{id}/templates"
                     * @param {string} id - the api space Id
                     * @param {object} data - the template data
                     */
                    function updateTemplate(id, data) {

                        return $http.put(urlBase + "/apispaces/" + id + "/templates/" + encodeURIComponent(data.id), data)
                            .then(updateTemplateComplete)
                            .catch(updateTemplateFailed);

                        function updateTemplateComplete(response) {
                            return response.data;
                        }

                        function updateTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * DELETE "/apispaces/{id}/templates"
                     * @param {string} id - the api space Id
                     * @param {string} templateId - the template id
                     */
                    function deleteTemplate(id, templateId) {


                        return $http.delete(urlBase + "/apispaces/" + id + "/templates/" + encodeURIComponent(templateId))
                            .then(deleteTemplateComplete)
                            .catch(deleteTemplateFailed);

                        function deleteTemplateComplete(response) {
                            return response.data;
                        }

                        function deleteTemplateFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                }]);

})(window.angular);
